import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import { Modal, Button, Grid, Row, Col, Breadcrumb, Thumbnail} from 'react-bootstrap';
import ReactDOM from 'react-dom';



class ExeronEdm extends Component {
  constructor(props, context) {
    super(props, context);


        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.state = {
          show: false,
          product: 'Default',
          listItemsProperties: '',
          sizeType: '',
          sizeData: '',
          sizeMeas: '',
          pdfLink: '',
          pdfAlias: '',
          image: ''
        };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }



  handleUpdate(product) {
    var productTmp = JSON.parse(product);
    var productArr = productTmp[0].prop;
    this.setState({listItemsProperties: productArr.map((elementEx) =>
    <li key={elementEx.data}>{elementEx.data}</li>
    )});
    return (
      <ul>{this.state.listItemsProperties}</ul>
    );
  }

  componentDidMount() {
    var data;
    var builtTmp;
    var parseString = require('xml2js').parseString;

    fetch('/supplier/exeron/produkte/data_edm.xml')
      .then((r) => r.text())
      .then(text  => {
      if (this.props.location.search.includes("product")) {
        var searchArray = this.props.location.search.split("&")
        searchArray.forEach(subSearchArray =>{
          if (subSearchArray.includes("product")) {
            parseString(text, function (err, result) {
                data=result;
                var tmpOV = JSON.parse(JSON.stringify(result));
                data= tmpOV.maschinen.maschine;
                data.map((element) => {
                  if (subSearchArray.split("=")[1] == element.identifier) {
                    this.setState({product: element.Name, sizeData: element.sizeData, sizeMeas: element.sizeMeas, sizeType: element.sizeType, pdfLink: element.pdfLink, pdfAlias: element.pdfAlias, image: element.Image});
                    this.handleUpdate(JSON.stringify(element.properties));
                    this.handleShow();
                  }
              });
          }.bind(this));
        }});
      }
    });
  }



  render() {



      var data;
      var builtTmp;
      var parseString = require('xml2js').parseString;

        fetch('/supplier/exeron/produkte/data_edm.xml')
        .then((r) => r.text())
        .then(text  => {
          parseString(text, function (err, result) {
              data=result;
              var tmpOV = JSON.parse(JSON.stringify(result));
              data= tmpOV.maschinen.maschine;
              console.log(data);
              builtTmp = data.map((element) =>
              <Col xs={12} md={4}>
                <Thumbnail className="thumbNail" src={`/supplier/exeron/maschinen/${element.Image}`} alt={element.Name}>
                  <h3>{element.Name}</h3>
                  <p>{element.sizeType}</p>
                  <p>{element.sizeData} {element.sizeMeas} </p>
                  <br/>
                    <Button bsStyle="primary" onClick={() => {
                      this.setState({product: element.Name, sizeData: element.sizeData, sizeMeas: element.sizeMeas, sizeType: element.sizeType, pdfLink: element.pdfLink, pdfAlias: element.pdfAlias, image: element.Image});
                      this.handleUpdate(JSON.stringify(element.properties));
                      this.handleShow();
                    }}>Mehr Informationen</Button>
                </Thumbnail>
              </Col>

              );

            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmp, document.getElementById('productsRoot'));
            console.log(this.builtElement);
        });
    return (
        <div className='container-fluid'>
          <div className="BCMain">
            <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
              <Breadcrumb.Item >
                <Link to="/Suppliers/WuF">WuF</Link>
              </Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers/Exeron">exeron</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>EDM</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <Grid>
            <Row id="productsRoot"></Row>
          </Grid>
        <Modal show={this.state.show} onHide={this.handleClose} >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.product}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid>
              <Row>
                <Col xsHidden md={12}>
                  <img className="imageSupProdModal" src={`/supplier/exeron/maschinen/${this.state.image}`} alt={this.state.product}/>
                </Col>
              </Row>
            </Grid>
            <h5>{this.state.sizeType}</h5>
            <p>{this.state.sizeData} &nbsp; {this.state.sizeMeas}</p>
            <br/>
            <h5>Eigenschaften</h5>
            <ul className='unordEnumBase'>{this.state.listItemsProperties}</ul>
            <br/>
            <h5>Download</h5>
            <a href={this.state.pdfLink}>{this.state.pdfAlias}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Schließen</Button>
          </Modal.Footer>
        </Modal>
      </div>

    );
  }
  }

export default ExeronEdm;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/exeron/subpages/edm.js